//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/form'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popup'
import 'devextreme/ui/select_box'
import 'devextreme/ui/tabs'

//#endregion

import { DashboardDestinationLevelPopupController } from "./destination-level-popup.controller"
import { USER_SESSION_SERVICE_NAME } from "../../../services/user-session"
import { DASHBOARD_SERVICE_NAME } from "../dashboard.service"

//#region Asset Imports

import './destination-level-popup.scss'
import * as TEMPLATE from './destination-level-popup.tpl.html'

//#endregion

export const DASHBOARD_DESTINATION_LEVEL_POPUP_NAME = 'dashboardDestinationLevelPopup'

export class DashboardDestinationLevelPopupComponent implements ng.IComponentOptions {
    controller = ['$q', '$timeout', USER_SESSION_SERVICE_NAME, DASHBOARD_SERVICE_NAME, DashboardDestinationLevelPopupController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE
}